import {
  SlopedRoofTypeTypes,
  ToitEnPenteClimateTypes,
  ToitEnPenteInsulationTypes,
  ToitEnPenteRainCoverTypes,
  ToitEnPenteStructureTypes,
} from "@iko-design-center/shared"

export function getToitEnPenteClimateTranslations(
  t: any,
  type: ToitEnPenteClimateTypes
) {
  switch (type) {
    case ToitEnPenteClimateTypes.PLAIN_CLIMATE:
      return t("toitEnPente.toitClimate.PLAIN_CLIMATE")
    case ToitEnPenteClimateTypes.MOUNTAINOUS_CLIMATE:
      return t("toitEnPente.toitClimate.MOUNTAINOUS_CLIMATE")
  }
}
export function getToitEnPenteStructureTranslations(
  t: any,
  type: ToitEnPenteStructureTypes
) {
  switch (type) {
    case ToitEnPenteStructureTypes.ON_WOOD_RAFTERS:
      return t("toitEnPente.toitStructure.ON_WOOD_RAFTERS")
    case ToitEnPenteStructureTypes.ON_WOOD_BOARDS:
      return t("toitEnPente.toitStructure.ON_WOOD_BOARDS")
    case ToitEnPenteStructureTypes.CONFORM_TO_MOUNTAINOUS_CLIMATE:
      return t("toitEnPente.toitStructure.CONFORM_TO_MOUNTAINOUS_CLIMATE")
  }
}

export function getToitEnPenteRainCoverTranslations(
  t: any,
  type: ToitEnPenteRainCoverTypes
) {
  switch (type) {
    case ToitEnPenteRainCoverTypes.RAIN_COVER_PRESENT:
      return t("toitEnPente.toitRainCover.RAIN_COVER_PRESENT")
    case ToitEnPenteRainCoverTypes.RAIN_COVER_ABSENT:
      return t("toitEnPente.toitRainCover.RAIN_COVER_ABSENT")
  }
}

export function getToitEnPenteRoofTypeTranslations(
  t: any,
  type: SlopedRoofTypeTypes
) {
  switch (type) {
    case SlopedRoofTypeTypes.TILED_ROOF:
      return t("slopedRoof.roofType.tiledRoof")
    case SlopedRoofTypeTypes.SLATED_ROOF:
      return t("slopedRoof.roofType.slatedRoof")
  }
}

export function getToitEnPenteInsulationTranslations(
  t: any,
  type: ToitEnPenteInsulationTypes
) {
  switch (type) {
    case ToitEnPenteInsulationTypes.ALU_NF_AS:
      return t("material.ENERTHERM_ALU_NF_AS")
  }
}
